import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.security');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-security',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.security/view.scss */
/* src/app/page.security/view.scss: no such file or directory */`],
})
export class PageSecurityComponent implements OnInit {
    public alerts: any[] = [
        { severity: 'critical', category: '경로 노출', title: '허용되지 않은 공유 경로 감지', description: '\\\\fab-share\\public 경로가 이관 규칙에 포함되어 자동 차단되었습니다.', source: 'PHOTO-21', detectedAt: '15:27:18', status: '조치 필요' },
        { severity: 'high', category: '권한 오류', title: '대상 저장소 쓰기 권한 거부', description: 'svc_migration 계정의 Overlay 저장소 쓰기 권한이 거부되었습니다.', source: 'AUTH-GW', detectedAt: '14:42:07', status: '검토 중' },
        { severity: 'medium', category: '이상 접근', title: '단시간 대량 파일 다운로드', description: '동일 단말에서 10분 이내 14개 파일 다운로드가 발생했습니다.', source: '10.24.18.72', detectedAt: '13:18:44', status: '모니터링' },
        { severity: 'resolved', category: '무결성', title: 'Excel 매크로 서명 불일치', description: '재검증 후 승인된 서명으로 확인되어 이벤트가 종료되었습니다.', source: 'CMP-04', detectedAt: '11:06:29', status: '해결' }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public severityLabel(severity: string) {
        const labels: any = { critical: '긴급', high: '높음', medium: '주의', resolved: '해결' };
        return labels[severity] || severity;
    }

    public severityClass(severity: string) {
        const classes: any = {
            critical: 'border-rose-200 bg-rose-50 text-rose-700',
            high: 'border-amber-200 bg-amber-50 text-amber-700',
            medium: 'border-blue-200 bg-blue-50 text-blue-700',
            resolved: 'border-emerald-200 bg-emerald-50 text-emerald-700'
        };
        return classes[severity] || 'border-slate-200 bg-slate-50 text-slate-600';
    }
}

export default PageSecurityComponent;